export default {
	state: () => ({
		data: { }
	}),
	mutations: {
		['thanks/setState'](state, payload) {
			state.data = { ...payload };
		},
		['thanks/removeMonobankError'](state) {
			try {
				const payData = JSON.parse(state?.data?.order?.payData);

				state.data = {
					...state.data,
					order: {
						...state?.data?.order,
						payData: JSON.stringify({ ...payData, status: '' }),
					},
				}
			} catch (err) {
			    console.error(err);
			}
		}
	},
	actions: {
		async ['thanks/updatePayData']({ state, commit }, payload) {
			try {
				const { status, data: dataResponse } = await axios.get(location.href, {
					params: {
						action: 'Y',
						// api: 'Y'
					}
				});

				if (status !== 200) throw 'something went wrong!!';

				commit('thanks/setState', {
					...state.data,
					order: {
						...state.data.order,
						payData: JSON.stringify(dataResponse),
					}
				})
			} catch (err) {
				console.error(err);
			}
		}
	},
	getters: {
		['thanks/getPayData']({ data: { order } }) {
			 if (order?.payData) {
				return JSON.parse(order.payData || '{}');
			 }
		}
	}
}